module.exports = __webpack_public_path__ + "media/images/socials/twitter-16dcb01bc6148c3e5f50527f3f745220.png";